import { type ActionFunction, data, redirect } from 'react-router-dom';
import { SelectedDealerIdsSchema } from '@/models/entities/lead.ts';
import { dealerService } from '@/services/dealerService.ts';

export const changeDealersAction: ActionFunction = async (args) => {
  const formData = await args.request.formData();
  const selectedDealerIds = formData.getAll('selectedDealerId');
  const validatedDealerIds =
    SelectedDealerIdsSchema.safeParse(selectedDealerIds);

  if (!validatedDealerIds.success) {
    return data(
      {
        error: 'At least one dealer must be selected',
      },
      { status: 400 },
    );
  }

  dealerService.setSelectedDealerIds(validatedDealerIds.data);

  const nextSearchParams = new URLSearchParams(globalThis.location.search);

  const query = nextSearchParams.toString();
  const redirectUrl = query ? `/leads?${query}` : '/leads';

  return redirect(redirectUrl);
};
